import { render } from "./CoursePopup.vue?vue&type=template&id=b01e5cfc&scoped=true"
import script from "./CoursePopup.vue?vue&type=script&lang=js"
export * from "./CoursePopup.vue?vue&type=script&lang=js"

import "./CoursePopup.vue?vue&type=style&index=0&id=b01e5cfc&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b01e5cfc"]])

export default __exports__